import { ModelConceptAttributeWithHierarchyData } from 'src/containers/ProjectDiagram/types/data';
import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { getAllInheritedAttributes } from 'src/containers/ProjectDiagram/utils/getAllInheritedAttributes';
import { getClassHierarchy } from 'src/containers/ProjectDiagram/utils/getClassHierarchy';
import { getProjectAttributesByDomain } from 'src/utils/getProjectAttributesByDomain';

export const getInheritedAttributesByClass = (
  model: Model | ModelSnapshot,
  classIris?: string[]
) => {
  const classIrisForHierarchy = model.nodeDataArray.reduce<Set<string>>(
    (acc, nodeData) => {
      if (isModelConceptClass(nodeData)) {
        acc.add(nodeData.value);
      }
      return acc;
    },
    new Set()
  );
  const attributesByDomain = getProjectAttributesByDomain(
    model.modelData.attributesByIri
  );
  const hierarchyByIri = getClassHierarchy(
    model.linkDataArray,
    classIrisForHierarchy
  );
  const inheritedAttributesByClass = Array.from(
    classIris || classIrisForHierarchy
  ).reduce<
    Record<string, Record<string, ModelConceptAttributeWithHierarchyData>>
  >(
    (agg, classIri) => ({
      ...agg,
      [classIri]: getAllInheritedAttributes({
        classIri,
        hierarchyByIri,
        attributesByDomain,
      }),
    }),
    {}
  );

  return inheritedAttributesByClass;
};
